import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Routes, Router } from '@angular/router';


import { Http } from '@angular/http';
import { AuthHttp, tokenNotExpired } from 'angular2-jwt';
import { TranslateService } from '@ngx-translate/core';

import { BaMenuService } from '../../theme';
import { BaPageTopComponent } from '../../theme/components';
import { AccountComponent } from '../employee/pages/account/account.component';

import { LoginService } from '../employee/service/login/login.service';
import { AccountService } from '../employee/service/account/account.service';
import { Message } from 'primeng/primeng';
import { Permission } from '../employee/class/permission';
import { HasPermissionService } from '../employee/service/has-permission/has-permission.service';
import { NotificationsService } from '../../theme/services/notifications/notifications.service';
import { Role } from '../employee/class/role';


@Component({
  selector: 'app-candidate',
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.css']
})
export class CandidateComponent implements OnInit, OnChanges {
  currentLang: string;
  public msgs: Message[] = [];
  public ImgPerfile: string;
  public menu: any;
  public permissions: Permission[];
  public roles: Role[];

  constructor(
    private _menuService: BaMenuService,
    private loginService: LoginService,
    private accountService: AccountService,
    private translate: TranslateService,
    public router: Router,
    // public baPageTop: BaPageTop,
    // public accountComponent: AccountComponent,
    private notificationsService: NotificationsService
  ) {
    this.currentLang = 'es';
    this.translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);
  }

  ngOnInit() {
    this.ImgPerfile = JSON.parse(localStorage.getItem('profile')).avatar;
    this.currentLang = JSON.parse(localStorage.getItem('profile')).language;

    this.translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);
    this.permissions = JSON.parse(localStorage.getItem('permissions'));
    this.roles = JSON.parse(localStorage.getItem('profile')).roles;
    this.createMenu();
    // this.getAccount();
    // this.getAccountPermissions();
  }

  ngOnChanges(changes: SimpleChanges): void {

  }
  public getAccount() {
    if (this.loginService.loggedIn()) {
      this.accountService.getAccount().toPromise().then(
        response => {
          localStorage.setItem('profile', JSON.stringify(response.json()));
          this.ImgPerfile = JSON.parse(localStorage.getItem('profile')).avatar;
          this.currentLang = JSON.parse(localStorage.getItem('profile')).language;

          this.translate.setDefaultLang(this.currentLang);
          this.translate.use(this.currentLang);
          // this.changeLanguage(this.currentLang);
        },
        error => {
          if (error.status === 401) {
            // localStorage.removeItem('token');
            // this.router.navigateByUrl('/login');
          }
        }
      );
    }
  }

  public getAccountPermissions() {
    if (this.loginService.loggedIn()) {
      this.accountService.getAccountPermissions().toPromise().then(
        response => {
          this.permissions = response.json();
          localStorage.setItem('permissions', JSON.stringify(this.permissions));

          this.createMenu();
          // this.changeLanguage(this.currentLang);
        },
        error => {
          if (error.status === 401) {
            // localStorage.removeItem('token');
            // this.router.navigateByUrl('/login');
          }
        }
      );
    }
  }

  public createMenu() {
    this.menu = [
      {
        path: 'candidate',
        children: [
          {
            path: 'account',
            data: {
              menu: {
                title: 'account',
                icon: 'fa fa-home',
                selected: false,
                expanded: false,
                hidden: true,
                order: 0
              }
            }
          },
          {
            path: 'curriculum',
            data: {
              menu: {
                title: 'curriculum',
                icon: 'fa fa-user-circle',
                selected: false,
                expanded: false,
                hidden: false,
                order: 0
              }
            }
          },
          {
            path: 'vacancies',
            data: {
              menu: {
                title: 'vacancies',
                icon: 'fa fa-folder-open',
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu('Candidate', this.roles),
                order: 0
              }
            }
          },
          /*{
            path: 'applications',
            data: {
              menu: {
                title: 'my applications',
                icon: 'fa fa-folder-open',
                selected: false,
                expanded: false,
                hidden: false,
                order: 0
              }
            }
          },*/
          {
            path: 'disabilities',
            data: {
              menu: {
                title: 'disabilities',
                icon: 'fa fa-stethoscope',
                selected: false,
                expanded: false,
                hidden: this.isHiddenMenu('Candidate', this.roles),
                order: 0
              }
            }
          },
        ]
      }

    ];
    this._menuService.updateMenuByRoutes(<Routes>this.menu);
  }

  public isHiddenMenu(element, list) {
    let hidden = false;
    let itera = 0;
    list.forEach(elementList => {
      if (elementList.name === element) {
        hidden = true;
      }
      itera++;
    });
    return !hidden;
  }

  public changeLanguage(lang) {
    this.accountService.updateProfile({ 'language': lang }).toPromise().then(
      response => {
        this.currentLang = lang;
        this.translate.use(this.currentLang);
        // this.baPageTop.languageChaged(this.lang);
        // this.accountComponent.getProfile();
        this._menuService.updateMenuByRoutes(<Routes>this.menu);
      },
      error => {
        console.log(error);
      }
    );
  }

  public showVersion() {
    const version = 'Luciana - Redes Humanas S. A. | 3.0.2';
    console.log(version);
    this.notificationsService.growlNotify('info', version);
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/candidate.component.ts